// Most of these logic should be removed as it's for backwards compatibility

import { LANGUAGE } from 'shared/constants/users';
import { LANGUAGE_CODE } from 'utils/intl';

export const getTagContent = (tag) => {
  if (tag.content) {
    return tag.content;
  }
  return tag;
};

export const getTagDisplayName = (tag, language) => {
  if (tag.displayName) {
    return tag.displayName[language] || tag.displayName[LANGUAGE.ENGLISH];
  }
  return tag.labelText;
};

// Language detection function (reuse from ReportUtils.jsx)
export const detectLanguage = (text) => {
  if (!text || typeof text !== 'string') return LANGUAGE_CODE.ENGLISH;

  // Japanese character ranges in Unicode
  const hiragana = /[\u3040-\u309F]/; // Hiragana
  const katakana = /[\u30A0-\u30FF]/; // Katakana
  const japaneseKanji = /[\u4E00-\u9FAF\u3400-\u4DBF]/; // CJK Unified Ideographs

  // Chinese character ranges in Unicode
  const chineseSimplified = /[\u4E00-\u9FFF]/; // CJK Unified Ideographs
  const chineseTraditional = /[\u3400-\u4DBF]/; // CJK Extension A

  // English/Latin character ranges
  const latin = /[a-zA-Z]/;

  // Count character types
  let japaneseCount = 0;
  let chineseCount = 0;
  let latinCount = 0;

  for (let i = 0; i < text.length; i++) {
    const char = text[i];

    if (hiragana.test(char) || katakana.test(char)) {
      japaneseCount++;
    } else if (japaneseKanji.test(char)) {
      // Kanji can be either Japanese or Chinese
      // If we have hiragana/katakana in the text, it's likely Japanese
      if (hiragana.test(text) || katakana.test(text)) {
        japaneseCount++;
      } else {
        chineseCount++;
      }
    } else if (chineseSimplified.test(char) || chineseTraditional.test(char)) {
      chineseCount++;
    } else if (latin.test(char)) {
      latinCount++;
    }
  }

  // Determine language based on character counts
  const totalChars = japaneseCount + chineseCount + latinCount;
  if (totalChars === 0) return LANGUAGE_CODE.ENGLISH;
  if (japaneseCount > 0) {
    return LANGUAGE_CODE.JAPANESE;
  }
  if (chineseCount > 0) {
    return LANGUAGE_CODE.CHINESE;
  }
  // Default to English for Latin characters or mixed content
  return LANGUAGE_CODE.ENGLISH;
};

// Get appropriate font family based on detected language
export const getFontFamilyForText = (text) => {
  const detectedLanguage = detectLanguage(text);

  switch (detectedLanguage) {
    case LANGUAGE_CODE.JAPANESE:
      return 'NotoSansJP';
    case LANGUAGE_CODE.CHINESE:
      return 'NotoSansCN';
    case LANGUAGE_CODE.ENGLISH:
    default:
      return 'NotoSans';
  }
};
